<template>
  <div class="orderNav">
    <el-submenu index="1">
      <template slot="title">
        <i class="iconfont icon-dingdan"></i>
        <span>{{ ptitle }}</span>
      </template>
      <el-menu-item
        v-for="(item, i) in menuList"
        :key="i"
        :index="item.index"
        @click="rediret(item)"
      >
        <span slot="title">{{ item.title }}</span>
      </el-menu-item>
    </el-submenu>
  </div>
</template>
<script>
export default {
  data() {
    return {
      ptitle: "订单管理",
      menuList: [
        {
          index: "1-1",
          title:
            localStorage.getItem("is_jgj") === "1"
              ? "待处理订单"
              : "三方备货出库单", // 判断是否为紧固件,
          url:
            localStorage.getItem("is_jgj") === "1"
              ? "/order/manageFastener"
              : "/order/manage", // 判断是否为紧固件
        },
      ],
    };
  },
  created() {
    this.getCurrentIndex(this.$route.path);
  },
  methods: {
    getCurrentIndex(path) {
      if (path.search("order") !== -1) {
        let selectItem = this.menuList.filter((item) => item.url === path);
        this.rediret(selectItem[0]);
      }
    },
    rediret(item) {
      this.$emit("rediret", item);
    },
  },
};
</script>
<style lang="scss">
.orderNav {
  border-top: 1px solid rgb(33, 42, 50);
}
</style>



// WEBPACK FOOTER //
// src/components/layout/leftnav/orderNav.vue